if (!window.BarelyTamedPdpPaymentDetails) {
  window.BarelyTamedPdpPaymentDetails = true;

  const relocatePaymentDetails = () => {
    document.querySelectorAll('.product-form').forEach((productForm) => {
      const destination = productForm.querySelector('.pdp-payment-details');
      if (!destination) return;

      const sezzleSlot = destination.querySelector('[data-pdp-payment-slot="sezzle"]');
      const termsSlot = destination.querySelector('[data-pdp-payment-slot="terms"]');
      const afterpaySlot = destination.querySelector('[data-pdp-payment-slot="afterpay"]');

      const sezzle = productForm.querySelector(
        '.product-info__price .sezzle-shopify-info-button',
      );
      if (sezzle && sezzle.parentElement !== sezzleSlot) {
        sezzleSlot.append(sezzle);
      }

      const terms = productForm.querySelector('.price-container > .price-descriptors');
      if (terms && terms.parentElement !== termsSlot) {
        termsSlot.append(terms);
      }

      const afterpay = productForm.querySelector('square-placement');
      const afterpayBlock = afterpay?.closest('.shopify-app-block');
      const afterpayWrapper = afterpayBlock?.parentElement?.classList.contains('not-in-quickbuy')
        ? afterpayBlock.parentElement
        : afterpayBlock;
      if (afterpayWrapper && afterpayWrapper.parentElement !== afterpaySlot) {
        afterpaySlot.append(afterpayWrapper);
      }
    });
  };

  let relocationFrame = null;
  const scheduleRelocation = () => {
    if (relocationFrame) return;

    relocationFrame = requestAnimationFrame(() => {
      relocationFrame = null;
      relocatePaymentDetails();
    });
  };

  relocatePaymentDetails();

  const observer = new MutationObserver(scheduleRelocation);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
